/* eslint-disable */
import connect from '../axios/axios.auth';
import numeral from 'numeral';
import download from 'downloadjs'

const reportesFunctions = {
  sucursales: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/flujo`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  diariobol: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/boletas/`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  diario: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/diario`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  excelSoldReportV2: (data) => {
    return new Promise(() => {
      connect.post(`/reportes/excel/boletas/`, data, { responseType: 'blob' })
      .then((response) => {
        const content = response.headers['content-type'];
        download(response.data, `VENTAS.xlsx`, content)
      });
    })
  },
  excelSoldReport: (data) => {
    return new Promise(() => {
      connect.post(`/reportes/excel/sold`, data, { responseType: 'blob' })
      .then((response) => {
        const content = response.headers['content-type'];
        download(response.data, `VENTAS.xlsx`, content)
      });
    })
  },
  master: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/master`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  pesoPies: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/pesopie`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  }, 
  manifiesto: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/manifiesto`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  manifiestoestado: (data) => {
    return new Promise((resolve) => {
      connect.post(`/reportes/manifiesto-estados`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  calulateBultos: (arr2) => {
    let new_arr = arr2.reduce((ar, obj) => {
      let bool = false;
      if (!ar) {
        ar = [];
      }
      ar.forEach((a) => {
        if (a.pie === obj.pie) {
          a.count++;
          bool = true;
        }
      });
      if (!bool) {
        obj.count = 1;
        ar.push(obj);
      }
      return ar;
    }, []);

    return new_arr;
  },
  piestotales: (bultos, comma = false) => {
    let total = 0;
    bultos.map((e) => {
      total +=  e.pie
    });

    return comma ? (total).toLocaleString("pt-BR") : numeral(total).format('0.00');
  },
  kgtotales: (bultos, comma = false) => {
    let total = 0;
    bultos.map((e) => {
      total +=  e.peso
    });
    return comma ? (total).toLocaleString("pt-BR") : numeral(total).format('0.00');
  }
}

export default reportesFunctions;